import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Truck, CreditCard, ShieldCheck } from 'lucide-react';
const announcements = [
  { icon: Truck, text: 'Frete grátis para todo o Brasil' },
  { icon: CreditCard, text: 'Parcele em até 12x no cartão' },
  { icon: ShieldCheck, text: 'Compra 100% segura' },
];
export default function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const [interacting, setInteracting] = useState(false);
  const [reduced, setReduced] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const change = () => setReduced(media.matches);
    media.addEventListener('change', change);
    return () => media.removeEventListener('change', change);
  }, []);
  useEffect(() => {
    if (interacting || reduced) return;
    const timer = window.setInterval(() => setIndex(value => (value + 1) % announcements.length), 4000);
    return () => window.clearInterval(timer);
  }, [interacting, reduced]);
  const item = announcements[index];
  const Icon = item.icon;
  return <div className="announcement-carousel" role="region" aria-label="Vantagens da loja" aria-roledescription="carrossel"
    onMouseEnter={() => setInteracting(true)} onMouseLeave={() => setInteracting(false)}
    onFocus={() => setInteracting(true)} onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setInteracting(false); }}>
    <div className="announcement-controls">
      <button type="button" aria-label="Mensagem anterior" onClick={() => setIndex(value => (value + 2) % 3)}><ChevronLeft size={18} /></button>
      <div className="announcement-message" key={index}><Icon size={18} aria-hidden="true" /><span>{item.text}</span></div>
      <button type="button" aria-label="Próxima mensagem" onClick={() => setIndex(value => (value + 1) % 3)}><ChevronRight size={18} /></button>
    </div>
  </div>;
}
